module.exports = __webpack_public_path__ + "static/2.d5089176.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider/2.png
// module id = 446
// module chunks = 35783957827783